export default __webpack_public_path__ + "static/media/icetruck.f73e1b1e.svg";